<template>
  <div style="text-align: right;">
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Módosítás'"
      placement="top"
      v-can="'data.owncompany.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateOwnCompany"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'data.owncompany.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteOwnCompany"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  props: ['ownCompany'],
  data() {
    return {
      deleteButtonLoader: false,
      deleteConfirmVisible: false
    };
  },
  methods: {
    async deleteOwnCompany() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('ownCompany/delete', this.ownCompany.id);
        this.$store.dispatch('ownCompany/fetchAll');
      } catch (e) {
      }
      this.deleteButtonLoader = false;
    },
    async updateOwnCompany() {
      this.$router.push('/data/own-companies/update/' + this.ownCompany.id);
    }
  }
};
</script>
